const byteSizeOfFloat = Float32Array.BYTES_PER_ELEMENT;

export const VertexType = {
    VT_Vertex2: "vertex2",
    VT_Vertex3: "vertex3",
    VT_Vertex3Normal3Color3: "vertex3Normal3Color3",
    VT_Vertex3Normal3: "vertex3Normal3",
    VT_Vertex3Normal3BatchID1: "vertex3Normal3BatchID1",
    VT_Vertex3Normal3Color3BatchID1: "vertex3Normal3Color3BatchID1",
    VT_Vertex4: "vertex4",
    VT_VertexColor4: "vertexColor4",
    VT_VertexColorNormal4: "vertexColorNormal4",
    VT_VertexColorUv4: "vertexColorUv4",
    VT_VertexNormalUv3: "vertexNormalUv3",
};

class wgVertexLayout {
    constructor(attLocation, attDimension, attDataType, offset, stride) {
        this.attLocation_ = attLocation;
        this.attDimension_ = attDimension;
        this.attDataType_ = attDataType;
        this.stride_ = stride;
        this.offset_ = offset;
    }

    getType() {
        return this.attType_;
    }
    getShaderAttribLocation() {
        return this.attLocation_;
    }
    getOffset() {
        return this.offset_;
    }
    getStride() {
        return this.stride_;
    }
}

class wgVertexDescriptor {
    constructor(vertexType, gl) {
        this.vertexType_ = vertexType;
        this.vertexLayout_ = [];

        switch (this.vertexType_) {
            case VertexType.VT_Vertex2:
                this.sizeInBytes_ = 2 * byteSizeOfFloat;
                this.vertexLayout_.push(new wgVertexLayout(0, 2, gl.FLOAT, 0, 0));
                break;
            case VertexType.VT_Vertex3:
                this.sizeInBytes_ = 3 * byteSizeOfFloat;
                this.vertexLayout_.push(new wgVertexLayout(0, 3, gl.FLOAT, 0, 0));
                break;
            case VertexType.VT_Vertex3Normal3:
                this.sizeInBytes_ = 6 * byteSizeOfFloat;
                this.vertexLayout_.push(new wgVertexLayout(0, 3, gl.FLOAT, 0, this.sizeInBytes_)); // Position
                this.vertexLayout_.push(new wgVertexLayout(1, 3, gl.FLOAT, 3 * byteSizeOfFloat, this.sizeInBytes_)); // Normal
                break;
            case VertexType.VT_Vertex3Normal3BatchID1:
                this.sizeInBytes_ = 7 * byteSizeOfFloat;
                this.vertexLayout_.push(new wgVertexLayout(0, 3, gl.FLOAT, 0, this.sizeInBytes_)); // Position
                this.vertexLayout_.push(new wgVertexLayout(1, 3, gl.FLOAT, 3 * byteSizeOfFloat, this.sizeInBytes_)); // Normal
                this.vertexLayout_.push(new wgVertexLayout(2, 1, gl.FLOAT, 6 * byteSizeOfFloat, this.sizeInBytes_)); // BatchID
                break;
            case VertexType.VT_Vertex3Normal3Color3:
                this.sizeInBytes_ = 9 * byteSizeOfFloat;
                this.vertexLayout_.push(new wgVertexLayout(0, 3, gl.FLOAT, 0, this.sizeInBytes_)); // Position
                this.vertexLayout_.push(new wgVertexLayout(1, 3, gl.FLOAT, 3 * byteSizeOfFloat, this.sizeInBytes_)); // Normal
                this.vertexLayout_.push(new wgVertexLayout(2, 3, gl.FLOAT, 6 * byteSizeOfFloat, this.sizeInBytes_)); // Color
                break;
            case VertexType.VT_Vertex3Normal3Color3BatchID1:
                this.sizeInBytes_ = 10 * byteSizeOfFloat;
                this.vertexLayout_.push(new wgVertexLayout(0, 3, gl.FLOAT, 0, this.sizeInBytes_)); // Position
                this.vertexLayout_.push(new wgVertexLayout(1, 3, gl.FLOAT, 3 * byteSizeOfFloat, this.sizeInBytes_)); // Normal
                this.vertexLayout_.push(new wgVertexLayout(2, 3, gl.FLOAT, 6 * byteSizeOfFloat, this.sizeInBytes_)); // Color
                this.vertexLayout_.push(new wgVertexLayout(3, 1, gl.FLOAT, 9 * byteSizeOfFloat, this.sizeInBytes_)); // BatchID
                break;
            case VertexType.VT_Vertex4:
                this.sizeInBytes_ = 4 * byteSizeOfFloat;
                this.vertexLayout_.push(new wgVertexLayout(0, 4, gl.FLOAT, 0, 0));
                break;
            case VertexType.VT_VertexColor4:
                this.sizeInBytes_ = 8 * byteSizeOfFloat;
                this.vertexLayout_.push(new wgVertexLayout(0, 4, gl.FLOAT, 0, this.sizeInBytes_));
                this.vertexLayout_.push(new wgVertexLayout(1, 4, gl.FLOAT, 4 * byteSizeOfFloat, this.sizeInBytes_));
                break;
            case VertexType.VT_VertexColorUv4: //this may be redundant
                this.sizeInBytes_ = 10 * byteSizeOfFloat;
                this.vertexLayout_.push(new wgVertexLayout(0, 4, gl.FLOAT, 0, this.sizeInBytes_)); // Position
                this.vertexLayout_.push(new wgVertexLayout(1, 4, gl.FLOAT, 4 * byteSizeOfFloat, this.sizeInBytes_)); // Color
                this.vertexLayout_.push(new wgVertexLayout(2, 2, gl.FLOAT, 8 * byteSizeOfFloat, this.sizeInBytes_)); // Uv
                break;
            case VertexType.VT_VertexColorNormal4:
                this.sizeInBytes_ = 12 * byteSizeOfFloat;
                this.vertexLayout_.push(new wgVertexLayout(0, 4, gl.FLOAT, 0, this.sizeInBytes_)); // Position
                this.vertexLayout_.push(new wgVertexLayout(1, 4, gl.FLOAT, 4 * byteSizeOfFloat, this.sizeInBytes_)); // Color
                this.vertexLayout_.push(new wgVertexLayout(2, 4, gl.FLOAT, 8 * byteSizeOfFloat, this.sizeInBytes_)); // Normal
                break;
            case VertexType.VT_VertexNormalUv3: //this may be redundant
                this.sizeInBytes_ = 8 * byteSizeOfFloat;
                this.vertexLayout_.push(new wgVertexLayout(0, 3, gl.FLOAT, 0, this.sizeInBytes_)); // Position
                this.vertexLayout_.push(new wgVertexLayout(1, 3, gl.FLOAT, 3 * byteSizeOfFloat, this.sizeInBytes_)); // Normal
                this.vertexLayout_.push(new wgVertexLayout(2, 2, gl.FLOAT, 6 * byteSizeOfFloat, this.sizeInBytes_)); // Uv
                break;
        }
    }

    getVertexLayout() {
        return this.vertexLayout_;
    }
    getVertexSizeInBytes() {
        return this.sizeInBytes_;
    }
}

export { wgVertexLayout };
export { wgVertexDescriptor };
